<script lang="ts">
    import { afterUpdate } from 'svelte';
    import { tooltip } from '@svelte-plugins/tooltips';
    import { _ } from 'svelte-i18n';

    import { VehicleLimitSchema, type VehicleResponseType } from '../Vehicles/types';
    import VehicleLimitExceededIcon from './VehicleLimitExceededIcon.svelte';
    import { VehicleLimitItem } from './VehicleLimit/VehicleLimitItem';
    import { VehicleLimitApp } from './VehicleLimit/VehicleLimitApp';
    import VehicleLimitTooltip from './VehicleLimitTooltip.svelte';
    import type { Assignment } from './Assignment';
    import IconDot from '../../shared/Icons/IconDot.svelte';
    import { debug } from '../../../stores/store';
    import SuccessColor from '../../shared/SuccessColor.svelte';
    import WarningColor from '../../shared/WarningColor.svelte';
    import ErrorColor from '../../shared/ErrorColor.svelte';

    export let assignment: Assignment;
    export let routeType: string = 'base_route';
    export let vehicle: VehicleResponseType | undefined = undefined;
    export let warningThreshold: number | null = null;
    export let position: string = 'top';
    export let maxVisibleIcons: number = 2;

    let vla: VehicleLimitApp = new VehicleLimitApp();

    let hasNonNormativeOrders: boolean = false;

    let reseting: boolean = false;
    let recentAlerts: string = '';
    let alertLevel: string = 'success';
    let tooltipTitle: string = '';

    afterUpdate(() => {
        vla.reset();
        let limitItem = null;
        if (assignment.getVehicleId() && vehicle && assignment.getCountDeliveries() > 0) {
            for (let type of Object.keys(VehicleLimitSchema.shape)) {
                let routeLimitType = ({parcel_limit: 'parcels', weight_limit: 'total_weight'})[type] ?? '';
                limitItem = VehicleLimitItem.getVehicleLimit(type, assignment, assignment.getRouteInfo()?.options?.vehicle_limits?.[routeLimitType] || vehicle[type] || null, warningThreshold, routeType);
                if (limitItem) {
                    vla.addVehicleLimit(limitItem);
                };
            }
            limitItem = VehicleLimitItem.getVehicleLimit('time_window', assignment, 0, null, routeType);
            if (limitItem) {
                vla.addVehicleLimit(limitItem);
            }
            let vehicleStartTimeSeconds = assignment.getVehicleWorkTimeStartSeconds(vehicle);
            let vehicleEndTimeSeconds = assignment.getVehicleWorkTimeEndSeconds(vehicle);
            if (vehicleEndTimeSeconds !== null && vehicleStartTimeSeconds !== null && vehicleEndTimeSeconds <= vehicleStartTimeSeconds) {
                vehicleEndTimeSeconds += 24 * 3600;
            }
            limitItem = VehicleLimitItem.getVehicleLimit('work_time_start', assignment, vehicleStartTimeSeconds, null, routeType);
            if (limitItem) {
                vla.addVehicleLimit(limitItem);
            }
            limitItem = VehicleLimitItem.getVehicleLimit('work_time_end', assignment, vehicleEndTimeSeconds, null, routeType);
            if (limitItem) {
                vla.addVehicleLimit(limitItem);
            }
            hasNonNormativeOrders = VehicleLimitItem.hasNonNormativeOrder(assignment, routeType);
        }
        vla = vla;
        if (recentAlerts != JSON.stringify(vla.getVehicleLimits())) {
            if (vla.isAllVehicleLimitMet()) {
                alertLevel = hasNonNormativeOrders ? 'warning' : 'success';
                tooltipTitle = vla.getVehicleLimitsSet().length ? 'Vehicle_limits_met' : 'Vehicle_limits_unset';
            } else if (vla.getVehicleLimitsExceeded().length > 0) {
                alertLevel = 'error';
                tooltipTitle = 'Vehicle_limits_exceeded';
            } else {
                alertLevel = 'warning';
                tooltipTitle = 'Vehicle_limits_potentially_exceeded';
            }
            recentAlerts = JSON.stringify(vla.getVehicleLimits());
            reseting = true;
            setTimeout(function() { reseting = false; }, 0);
        }
    });

    // #4bae4f -- from Rafał's example
</script>

{#if assignment.getCountDeliveries() > 0 && !reseting}
    <span use:tooltip={{content: {component: VehicleLimitTooltip, props: {alerts: vla.getVehicleLimits(), values: true, percent: true, units: true, hasNonNormativeOrders: hasNonNormativeOrders, doubtReasons: vla.getDoubtReasons(), title: $_(tooltipTitle)}}, theme: 'lastmile-tooltip-no-events', position: position, maxWidth: 400}}>
        {#if alertLevel === 'error'}
            {#if vla.getVehicleLimitsExceededOrClose().length <= maxVisibleIcons}
                <div style="display: flex; flex-direction: row; align-items: center">
                {#each vla.getVehicleLimitsExceededOrClose() as limit}
                    <VehicleLimitExceededIcon {limit} {hasNonNormativeOrders}/>
                {/each}
                </div>
            {:else}
                <ErrorColor>
                    <IconDot scale={0.7}/>
                </ErrorColor>
            {/if}
        {:else if alertLevel === 'warning'}
            {#if vla.getVehicleLimitsExceededOrClose().length <= maxVisibleIcons}
                <div style="display: flex; flex-direction: row; align-items: center">
                {#each vla.getVehicleLimitsExceededOrClose() as limit}
                    <VehicleLimitExceededIcon {limit} {hasNonNormativeOrders}/>
                {/each}
                </div>
            {:else}
                <WarningColor>
                    <IconDot scale={0.7}/>
                </WarningColor>
            {/if}
        {:else}
            <SuccessColor>
                <IconDot scale={0.7}/>
            </SuccessColor>
        {/if}
    </span>
{/if}
